// plugins/common.js
export default {
    install(Vue) {
        Vue.prototype.$fenye = {

        }
    }
}
